import { isStringEmptyOrNull } from "../../../../utils/common";
import moment from 'moment';
import { MSG_EMPTY_REQUIRED, MSG_GREATER_ENDDATE, MSG_EXCEEDS_CHARACTER } from "../../../../utils/messages";

export const validateForm = (values) => {

    let errors = {};


    if (isStringEmptyOrNull(values.PollModel.pollTitle)) {
        errors[`PollModel.pollTitle`] = MSG_EMPTY_REQUIRED;
    } else if(125 < values.PollModel.pollTitle.length){ 
        errors[`PollModel.pollTitle`] = MSG_EXCEEDS_CHARACTER;
    }

    if ("" === values.PollModel.pollType) {
        errors["PollModel.pollType"] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.PollModel.pollDescription)) {
        errors[`PollModel.pollDescription`] = MSG_EMPTY_REQUIRED;
    } else if(255 < values.PollModel.pollDescription.length){
        errors[`PollModel.pollDescription`] = MSG_EXCEEDS_CHARACTER;
    }

    if (moment(values.PollModel.pollEndDate).isBefore(moment(values.PollModel.pollStartDate))) {
        errors[`PollModel.pollEndDate`] = MSG_GREATER_ENDDATE;
    }
    
    return errors;
    
}